import React, { memo, useMemo } from 'react';
import PropTypes from 'prop-types';
import { format } from 'date-fns';

import { getTimeframeItem } from 'components/Timeframe';
import { DAY, MONTH, RANGE } from 'consts';
import s from './styled';

const TimeframeValue = memo(function TimeframeValue(props) {
  const { timeframe } = props;
  const timeframeItem = useMemo(() => {
    return getTimeframeItem(timeframe, true);
  }, [timeframe]);

  return (
    <s.TimeframeWrapper>
      {!timeframe?.length && 'All time summary'}
      {timeframe?.length && (
        <>
          {timeframeItem.type === RANGE && (
            <>
              {format(timeframe[0], 'MM/dd/yyyy')} -{' '}
              {format(timeframe[1], 'MM/dd/yyyy')}
            </>
          )}
          {timeframeItem.type === DAY && (
            <>{format(timeframe[0], 'MM/dd/yyyy')}</>
          )}
          {timeframeItem.type === MONTH && (
            <>{format(timeframe[0], 'MM/yyyy')}</>
          )}
        </>
      )}
    </s.TimeframeWrapper>
  );
});

TimeframeValue.propTypes = {
  timeframe: PropTypes.array,
};

export default TimeframeValue;
